import './Tab.css';
import Box from './Box';
import React from 'react';
import Text from './Text';

export default function Tab(
  props: {
    children?: any;
    label: any;
    name?: string;
    selected?: boolean;
    onClick?(): void;
    searchParams?: object;
  }
) {
  return (
    <Box>
      <Box
        paddingVertical={14}
        paddingHorizontal={16}
        dividerColor={props.selected ? 'red' : ''}
        onClick={props.onClick}
        className='Tab'
      >
        <Text
          weight={'500'}
          lineHeight={24}
          color={props.selected ? 'red' : ''}
          noWrap
        >{props.label}</Text>
      </Box>
    </Box>
  );
}
